import {
  IPriceCorrectionLogs,
  IBackingEstimate,
} from '../../types/models/PriceCorrectionLogs';
import {
  FETCH_PRICE_CORRECTION_LOGS,
  FETCH_PRICE_CORRECTION_LOGS_SUCCESS,
  FETCH_PRICE_CORRECTION_LOGS_ERROR,
  FETCH_BACKING_ESTIMATE,
  FETCH_BACKING_ESTIMATE_SUCCESS,
  FETCH_BACKING_ESTIMATE_ERROR,
  PriceCorrectionLogsActionTypes,
} from '../../types/actions/PriceCorrectionLogs.actions';

export interface PriceCorrectionLogsState {
  data: IPriceCorrectionLogs | null;
  backingEstimate: IBackingEstimate | null;
  isLoading: boolean;
}

const initialState: PriceCorrectionLogsState = {
  data: null,
  backingEstimate: null,
  isLoading: false,
};

export default (
  state = initialState,
  action: PriceCorrectionLogsActionTypes,
): PriceCorrectionLogsState => {
  switch (action.type) {
    case FETCH_PRICE_CORRECTION_LOGS: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case FETCH_PRICE_CORRECTION_LOGS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        data: action.payload,
      };
    }
    case FETCH_PRICE_CORRECTION_LOGS_ERROR: {
      return {
        ...state,
        isLoading: false,
        data: null,
      };
    }
    case FETCH_BACKING_ESTIMATE: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case FETCH_BACKING_ESTIMATE_SUCCESS: {
      return {
        ...state,
        backingEstimate: action.payload,
        isLoading: false,
      };
    }
    case FETCH_BACKING_ESTIMATE_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }
    default:
      return state;
  }
};
